import {getParallelPoints, mmToInches} from "../../../../helpers/sqftHelper";
import config from "../../store/sqftConfig";
import SlabWorkspace from "./slabWorkspace";
import {hasCommonElements} from "../../../../helpers/dataHelper";

export const findSlabConflict = (sqftFeature, conflictIds) => {
  // 1. Direct feature ↔ conflict
  if (conflictIds.includes(sqftFeature.sqftId)) {
    return true;
  }

  // 2. Multiple sqftIds ↔ conflict
  if (hasCommonElements(conflictIds, sqftFeature.sqftIds)) {
    return true;
  }

  // 3. Through slab additional shapes (shapeId -> lineId)
  const slabAdditionalShapesWithConflicts = conflictIds.map(shapeId =>
    SlabWorkspace.slabAdditionalShapes.findOneByBacksplashShapeId(shapeId)
  ).filter(Boolean);
  const hasConflictViaAdditionalShape = slabAdditionalShapesWithConflicts
    .some(additionalShape =>
      additionalShape?.line?.id === sqftFeature.sqftId ||
      sqftFeature.sqftIds?.includes(additionalShape?.line?.id)
    );

  return hasConflictViaAdditionalShape;
};

export const getBacksplashesPos = (line, thickness = -5) => {
  thickness = config.measureUnit === "Imperial" ? thickness : mmToInches(thickness);
  const shape = line.getParent();
  let shapePoints = [];
  const parallelPoints = getParallelPoints(line.from, line.to, -thickness);
  shapePoints.push(...parallelPoints);
  shapePoints.push(line.from);
  shapePoints.push(line.to);

  return [shape.pos, shapePoints]
}

export const getShapePosAndPoints = (parent, from, to, thickness = -5) => {
  const shape = parent;
  let shapePoints = [];
  const parallelPoints = getParallelPoints(from, to, -thickness);
  shapePoints.push(...parallelPoints);
  shapePoints.push(from);
  shapePoints.push(to);

  return [shape.pos, shapePoints]
}

export const getBumpoutPointCords = (line) => {
  return line.bumpoutOverlay.getBumpoutPointCords()
}
